import { Navigate, RouteObject } from "react-router-dom";
import { lazy } from "react";

import App from "../App";

const HomePage = lazy(() => import("@/page/Home"));
const SocarPage = lazy(() => import("@/page/Socar"));
const AppPage = lazy(() => import("@/page/App"));
const GuestPage = lazy(() => import("@/page/Guest"));
const ErrorBoundary = lazy(() => import("@/page/error/ErrorBoundary.tsx"));
const Error404Page = lazy(() => import("@/page/error/Error404Page.tsx"));
const Error500Page = lazy(() => import("@/page/error/Error500Page.tsx"));

const routes: RouteObject[] = [
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: "",
                element: <HomePage />,
            },
            {
                path: "socar",
                element: <SocarPage />,
            },
            {
                path: "app",
                element: <AppPage />,
            },
            {
                path: "Guest",
                element: <GuestPage />,
            },
            {
                path: "404",
                element: <Error404Page />,
            },
            {
                path: "500",
                element: <Error500Page />,
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to="/404" />,
    },
];

export default routes;
